"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/CampaignPage/Body/MessagesTable/BulkControls/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _broadcast = require('shared/enum/broadcast');
var _broadcast3 = require('shared/selectors/broadcast');
var _hooks = require('web/services/hooks');

var _useToggle = require('shared/hooks/useToggle'); var _useToggle2 = _interopRequireDefault(_useToggle);


var _Tooltip = require('web/components/Tooltip');
var _RemoveConfirmationModal = require('./RemoveConfirmationModal'); var _RemoveConfirmationModal2 = _interopRequireDefault(_RemoveConfirmationModal);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _keyboard = require('web/services/keyboard');











const BulkControls = ({
  campaignKey,
  onClearAllRowsSelection,
  selectedPatientKeys,
  selectedStatuses,
  onRemovePatients,
  onDequeuePatients,
}) => {
  // Not yet being messaged: removable; queued: can come off the queue.
  const hasAny = selectedStatuses.length > 0
  const canRemove = hasAny && selectedStatuses.every(s => s === _broadcast.broadcastMsgStatus.NOT_SCHEDULED || s === _broadcast.broadcastMsgStatus.QUEUED)
  const canDequeue = hasAny && selectedStatuses.every(s => s === _broadcast.broadcastMsgStatus.QUEUED)
  const isCampaignArchived = _hooks.useAppSelector.call(void 0, state => _broadcast3.selectIsCampaignArchived.call(void 0, state, campaignKey))
  const { isOpen, onOpen, onClose } = _useToggle2.default.call(void 0, )
  const {
    isOpen: isRemoveConfirmationModalOpen,
    onOpen: onOpenRemoveConfirmationModal,
    onClose: onCloseRemoveConirmationModal,
  } = _useToggle2.default.call(void 0, )

  const onConfirmRemovingPatients = _react.useCallback.call(void 0, 
    () => {
      onRemovePatients(selectedPatientKeys)
      onClearAllRowsSelection()
    },
    [selectedPatientKeys, onClearAllRowsSelection, onRemovePatients],
  )

  const handleDequeue = _react.useCallback.call(void 0, 
    () => {
      onDequeuePatients(selectedPatientKeys)
      onClearAllRowsSelection()
    },
    [selectedPatientKeys, onClearAllRowsSelection, onDequeuePatients],
  )

  const selectedRowsLabel = selectedPatientKeys.length === 1
    ? '1 patient selected'
    : `${selectedPatientKeys.length} patients selected`

  const areNoActionsAvailable = !canRemove && !canDequeue

  const content = (
    _react2.default.createElement(_Tooltip.TooltipContent, { className: "campaign-table--bulk-controls--popup", __self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
      ,  canDequeue && (
        _react2.default.createElement(_Tooltip.TooltipMenuItem, {
          iconSrc: "/assets/icons/broadcast/dequeue.svg",
          label: "Remove from queue"  ,
          onClick: handleDequeue, __self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}
        )
      )
      ,  canRemove && (
        _react2.default.createElement(_Tooltip.TooltipMenuItem, {
          iconSrc: "/assets/icons/broadcast/remove.svg",
          disabled: isCampaignArchived,
          label: "Remove from campaign"  ,
          desc: isCampaignArchived ? "Can't remove patients from an archived campaign" : '',
          onClick: onOpenRemoveConfirmationModal, __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
        )
      )
      ,  areNoActionsAvailable && (
        _react2.default.createElement('span', { className: "campaign--table--bulk-controls--popup-no-actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}}, "No actions available"

        )
      )
    )
  )

  return (
    _react2.default.createElement('div', { className: "campaign--table--bulk-controls", __self: this, __source: {fileName: _jsxFileName, lineNumber: 96}}
      , _react2.default.createElement('span', { className: "campaign--table--bulk-controls--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 97}}
        ,  selectedRowsLabel 
      )
      , _react2.default.createElement(_Tooltip.ControlledTooltip, {
        isDismissibleByClickElsewhere: true,
        place: "bottom-left",
        isOpen: isOpen,
        onClose: onClose,
        content: content,
        className: "campaign--table--bulk-controls--toggle-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 100}}

        , _react2.default.createElement('div', {
          role: "button", tabIndex: 0, onKeyDown: _keyboard.onButtonKeyDown,
          onClick: onOpen,
          className: _classBuilder2.default.call(void 0, 
            "campaign--table--bulk-controls--toggle",
            isOpen && "campaign--table--bulk-controls--toggle-active",
          ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}
, "View options"

        )
      )
      , _react2.default.createElement(_RemoveConfirmationModal2.default, {
        isOpen: isRemoveConfirmationModalOpen,
        onClose: onCloseRemoveConirmationModal,
        patientsCount: selectedPatientKeys.length,
        onConfirm: onConfirmRemovingPatients, __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, BulkControls)
